"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouteLoader = void 0;
const react_1 = require("@remix-run/react");
const jotai_1 = require("jotai");
const react_2 = require("react");
const getAtom = (atom, key) => {
    let res;
    if (key.includes('+')) {
        // for atom family
        const [atomKey, ...args] = key.split('+');
        const decodeArgs = args.map((a) => decodeURIComponent(a));
        const atomFamily = (atom.atomFamilies || {})[atomKey];
        if (!atomFamily) {
            console.error('atomFamily not found for key: %s', key);
        }
        res = atomFamily(...decodeArgs);
    }
    else {
        // for plain atom
        res = (atom.atoms || {})[key];
    }
    if (process.env.NODE_ENV === 'development' && !res) {
        throw new Error(`no such atom for key: ${key}`);
    }
    return res;
};
const useRouteLoader = (method, params, atom) => {
    const store = (0, jotai_1.useStore)();
    const matches = (0, react_1.useMatches)();
    const stateRef = (0, react_2.useRef)('idle');
    const [state, setState] = (0, react_2.useState)('idle');
    const load = (0, react_2.useCallback)(() => {
        if (stateRef.current === 'loading') {
            return;
        }
        stateRef.current = 'loading';
        setState('loading');
        const url = new URL('', location.href);
        url.searchParams.set('method', method);
        url.searchParams.set('_data', matches.at(-1)?.id || '');
        Object.entries(params).forEach(([key, value]) => {
            url.searchParams.set(key, String(value));
        });
        window
            .fetch(url)
            .then((rsp) => rsp.json())
            .then((data) => {
            if (!data) {
                return;
            }
            try {
                Object.entries(data).forEach(([key, value]) => {
                    if (!key.startsWith('$')) {
                        return;
                    }
                    const atomToSet = getAtom(atom, key);
                    store.set(atomToSet, value);
                });
            }
            catch (e) {
                console.error(e);
            }
        })
            .catch(console.log)
            .finally(() => {
            stateRef.current = 'idle';
            setState('idle');
        });
    }, [method, params]);
    return {
        state,
        load,
    };
};
exports.useRouteLoader = useRouteLoader;
